// ignore-string-externalization

import qs from 'query-string';

const NETWORK_TIMEOUT = 150;

class Contentful {
  cache = new Map();

  setCache(url: $TSFixMe, response: $TSFixMe) {
    this.cache.set(url, {
      response,
      body: response.text(),
    });
  }

  async getCache(url: $TSFixMe) {
    if (this.cache.has(url)) {
      const { response, body } = this.cache.get(url);
      return new Response(await body, response);
    }

    return undefined;
  }

  async getEntries(
    query: $TSFixMe,
    smartlingLanguage: $TSFixMe,
    preview = false,
  ) {
    let host;
    let token;

    if (preview) {
      host = process.env.REACT_APP_CONTENTFUL_PREVIEW_HOST;
      token = process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN;
    } else {
      host = process.env.REACT_APP_CONTENTFUL_HOST;
      token = process.env.REACT_APP_CONTENTFUL_TOKEN;
    }

    const space = process.env.REACT_APP_CONTENTFUL_SPACE;
    const env = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT;
    const url = `https://${host}/spaces/${space}${
      env ? `/environments/${env}` : ''
    }/entries?${qs.stringify(query)}&locale=${smartlingLanguage}`;

    const fetching = fetch(url, {
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }).then(
      (response: $TSFixMe) => {
        if (response.ok) {
          this.setCache(url, response);
          return this.getCache(url);
        }
        if (preview && response.status === 401) {
          return {
            ...response,
            status: 200,
            ok: true,
            json: () => ({
              items: [],
            }),
          };
        }

        return response;
      },
      error =>
        this.getCache(url).then(
          cachedResponse => cachedResponse || Promise.reject(error),
        ),
    );

    return Promise.race([
      fetching,
      new Promise(resolve => {
        setTimeout(() => {
          resolve(
            this.getCache(url).then(
              cachedResponse => cachedResponse || fetching,
            ),
          );
        }, NETWORK_TIMEOUT);
      }),
    ]);
  }
}

export default new Contentful();
